export function getPilotoUUID(): string | null {
    try {
      const userData = localStorage.getItem('@Piloto:user');
      if (!userData) return null;
  
      const parsedUser = JSON.parse(userData);
      return parsedUser?.uuid || null;
    } catch (error) {
      console.error('Erro ao recuperar @Piloto:user do localStorage:', error);
      return null;
    }
}
  